import { Controller } from "@hotwired/stimulus"

// Универсальные модалки раздела: кнопка объявляет имя, модалка его носит.
//
//   <div data-controller="modal">
//     <button data-action="modal#open" data-modal-name-param="new">…</button>
//     <div data-modal="new"> … </div>
//   </div>
export default class extends Controller {
  open(e) { this._show(this.element.querySelector(`[data-modal="${e.params.name}"]`)) }
  close(e) { this._hide(e.currentTarget.closest("[data-modal]")) }
  backdrop(e) { if (e.target === e.currentTarget) this._hide(e.currentTarget) }

  disconnect() { this._unbindEsc() }

  _show(m) {
    if (!m) return
    m.classList.remove("hidden")
    m.classList.add("flex")
    this._unbindEsc()
    this._esc = (e) => { if (e.key === "Escape") this._hide(m) }
    document.addEventListener("keydown", this._esc)
    m.querySelector("input, select, textarea")?.focus()
  }

  _hide(m) {
    if (!m) return
    m.classList.add("hidden")
    m.classList.remove("flex")
    this._unbindEsc()
  }

  _unbindEsc() {
    if (this._esc) document.removeEventListener("keydown", this._esc)
    this._esc = null
  }
}
